"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/commons/shared.module.ts');
const router_1 = require("@angular/router");
const vasat_1 = require("vasat");
const global_1 = require("./global");
const _4d_mapper_1 = require("4d-mapper");
const identify_interface_1 = require("../xs/interfaces/identify.interface");
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
fontawesome_svg_core_1.library.add(pro_solid_svg_icons_1.fas, pro_regular_svg_icons_1.far, pro_light_svg_icons_1.fal, free_brands_svg_icons_1.fab);
class SharedModule {
    constructor() {
        this.__ID = identify_interface_1.XsIdentityInterface.__init(this);
    }
}
exports.SharedModule = SharedModule;
class LoginNeeded {
    constructor(V, r) {
        this.V = V;
        this.r = r;
        DEBUG_1.DEBUG.log('/app/commons/shared.module.ts', 'LoginNeeded CONSTRUCTOR');
    }
    canActivate(route, state) {
        if (this.V.localSession()) {
            return true;
        }
        else {
            this.r.navigate([global_1.AppRoutes.AUTH], { queryParams: { prevpage: state.url, msg: 'Login Timed out' } });
            return false;
        }
    }
}
exports.LoginNeeded = LoginNeeded;
class AccountNeeded extends LoginNeeded {
    constructor(fourD, r) {
        super(fourD.V, r);
        this.fourD = fourD;
        DEBUG_1.DEBUG.log('/app/commons/shared.module.ts', 'AccountNeeded CONSTRUCTOR');
    }
    canActivate(route, state) {
        if (!super.canActivate(route, state)) {
            return false;
        }
        if (!this.fourD.teams || !this.fourD.teams.length) {
            this.fourD.onReady().subscribe(s => {
                if (!this.fourD.teams.find(t => t.active)) {
                    this.r.navigate(['/app/admin/plan']);
                }
            });
            // still loading
            return true;
        }
        else if (this.fourD.teams.find(t => t.active)) {
            return true;
        }
        else {
            this.r.navigate(['/app/admin/plan']);
            return false;
        }
    }
}
exports.AccountNeeded = AccountNeeded;
